module.exports = __webpack_public_path__ + "img/赛道飞车.e6d80b32.png";